export const categories = [
  {
    id: 'milk-secretion',
    name: '奶水分泌原理',
    slug: 'milk-secretion',
    description: '了解母乳是如何产生的，掌握泌乳的科学机制',
    icon: 'ri-drop-fill',
    color: 'accent',
    articleCount: 8,
  },
  {
    id: 'feeding-positions',
    name: '哺乳姿势动画',
    slug: 'feeding-positions',
    description: '学习正确的哺乳姿势，让喂奶更轻松舒适',
    icon: 'ri-heart-pulse-fill',
    color: 'primary',
    articleCount: 10,
  },
  {
    id: 'milk-boosting',
    name: '追奶技巧',
    slug: 'milk-boosting',
    description: '科学追奶方法，帮助增加母乳分泌量',
    icon: 'ri-arrow-up-circle-fill',
    color: 'secondary',
    articleCount: 7,
  },
  {
    id: 'weaning',
    name: '断奶过渡',
    slug: 'weaning',
    description: '温和断奶方法，顺利过渡到辅食阶段',
    icon: 'ri-emotion-happy-fill',
    color: 'accent',
    articleCount: 6,
  },
];

export const articles = [
  {
    id: 1,
    slug: 'milk-secretion-process',
    title: '母乳分泌的全过程动画演示',
    excerpt: '从宝宝吸吮到乳汁分泌，一张动图看懂泌乳反射的完整过程。了解催乳素和催产素如何协同工作，让奶水自然流出。',
    content: `<p>每一位新手妈妈都好奇：奶水到底是怎么产生的？其实，母乳分泌是一个精妙的生理过程，涉及激素调节、神经反射和乳腺组织的协同配合。</p>
<h2>泌乳反射的科学原理</h2>
<p>当宝宝开始吸吮乳头时，乳晕下方的神经末梢受到刺激，信号会迅速传递到妈妈的大脑垂体。垂体前叶释放<strong>催乳素</strong>，促使乳腺细胞合成乳汁；垂体后叶释放<strong>催产素</strong>，引发乳腺导管周围的肌上皮细胞收缩，将乳汁挤压排出——这就是我们常说的"奶阵"或"泌乳反射"。</p>
<h2>泌乳的三个阶段</h2>
<p><strong>第一阶段：初乳期（孕晚期至产后2-3天）</strong><br />孕期乳腺已经在为哺乳做准备，产后最初几天分泌的是珍贵的初乳，量少但营养密度极高，富含免疫球蛋白。</p>
<p><strong>第二阶段：过渡乳期（产后3-10天）</strong><br />随着胎盘娩出后孕激素骤降，催乳素水平上升，奶水量显著增加，乳房可能出现胀满感，这就是"下奶"的过程。</p>
<p><strong>第三阶段：成熟乳期（产后10天以后）</strong><br />乳汁分泌进入稳定阶段，此时奶水分泌主要遵循"供需平衡"原则——宝宝吸吮越多，乳汁产生越多。</p>
<h2>影响奶水分泌的关键因素</h2>
<ul>
<li><strong>有效吸吮：</strong>宝宝含接姿势正确、吸吮有力是泌乳的基础</li>
<li><strong>排空频率：</strong>乳房越空，泌乳速度越快</li>
<li><strong>情绪状态：</strong>放松愉悦的心情促进催产素分泌</li>
<li><strong>营养水分：</strong>充足的营养和水分摄入是产奶的物质基础</li>
</ul>`,
    category: 'milk-secretion',
    categoryName: '奶水分泌原理',
    image: 'https://readdy.ai/api/search-image?query=Soft%20warm%20pastel%20illustration%20of%20breastfeeding%20anatomy%2C%20gentle%20scientific%20diagram%20style%2C%20mother%20and%20baby%20silhouette%20with%20flowing%20milk%20droplets%2C%20soft%20cream%20and%20rose%20color%20palette%2C%20minimalist%20educational%20illustration%2C%20clean%20background&width=800&height=500&seq=article-milk-secretion-01&orientation=landscape',
    readTime: 5,
    date: '2026-07-15',
    tags: ['泌乳原理', '催乳素', '初乳'],
    featured: true,
  },
  {
    id: 2,
    slug: 'correct-latch-position',
    title: '正确含接姿势动画教程',
    excerpt: '宝宝含接姿势不正确是乳头疼痛的主要原因。通过动画演示，学习正确的含乳姿势，让喂奶不再痛苦。',
    content: `<p>含接姿势是哺乳成功的关键第一步。许多新手妈妈遇到的乳头疼痛、奶水不足等问题，根源往往在于宝宝含接姿势不正确。</p>
<h2>正确含接的五个关键点</h2>
<p><strong>1. 宝宝的嘴巴要张大</strong><br />像打哈欠一样，上下唇外翻，下颌紧贴乳房，鼻子远离乳房，下巴深埋乳晕。</p>
<p><strong>2. 含住大部分乳晕</strong><br />宝宝不仅要含住乳头，更要含住乳头下方的大部分乳晕。乳头应位于宝宝口腔的上颚软硬腭交界处。</p>
<p><strong>3. 下唇外翻</strong><br />宝宝下唇像小鱼嘴一样外翻，舌头呈杯状包裹乳头和乳晕下方。</p>
<p><strong>4. 面颊饱满</strong><br />吸吮时宝宝的脸颊应保持饱满圆润，不凹陷。如果脸颊凹陷，说明含接不够深。</p>
<p><strong>5. 有节奏的吸吮-吞咽</strong><br />先快后慢，有节奏地吸吮几口后吞咽一次，能听到轻柔的吞咽声。</p>
<h2>常见含接问题及纠正</h2>
<ul>
<li><strong>乳头扁平或凹陷：</strong>哺乳前可轻轻牵拉乳头，或使用乳头矫正器</li>
<li><strong>宝宝嘴巴小：</strong>可采用"不对称含接法"，让宝宝下方含入更多乳晕</li>
<li><strong>妈妈乳房胀满：</strong>先挤出少许乳汁软化乳晕，便于宝宝含接</li>
</ul>`,
    category: 'feeding-positions',
    categoryName: '哺乳姿势动画',
    image: 'https://readdy.ai/api/search-image?query=Gentle%20illustration%20of%20correct%20breastfeeding%20latch%20technique%2C%20soft%20watercolor%20style%2C%20baby%20and%20mother%20close-up%2C%20warm%20cream%20and%20soft%20pink%20tones%2C%20educational%20medical%20illustration%2C%20clean%20minimal%20composition&width=800&height=500&seq=article-latch-02&orientation=landscape',
    readTime: 6,
    date: '2026-07-20',
    tags: ['含接姿势', '乳头疼痛', '哺乳技巧'],
    featured: true,
  },
  {
    id: 3,
    slug: 'cradle-hold-position',
    title: '摇篮式哺乳姿势详解',
    excerpt: '摇篮式是最经典的哺乳姿势，适合大多数妈妈和宝宝。通过动画分步骤学习正确的摇篮式抱法。',
    content: `<p>摇篮式（Cradle Hold）是哺乳姿势中最基础、最常用的一种，适合大多数足月顺产宝宝。掌握正确的摇篮式姿势，能让喂奶过程更加轻松舒适。</p>
<h2>摇篮式哺乳步骤</h2>
<p><strong>第一步：准备舒适的坐姿</strong><br />选择有扶手的椅子，背部靠在椅背上，脚下可垫一个小凳子。在腰后放置靠垫，手臂下方放置哺乳枕或枕头支撑宝宝。</p>
<p><strong>第二步：将宝宝的头部枕在臂弯</strong><br />如果用右侧乳房喂奶，用右前臂托住宝宝的身体，宝宝的头部枕在右臂肘弯处，右手托住宝宝的臀部或大腿。</p>
<p><strong>第三步：宝宝的身体呈一条直线</strong><br />宝宝的耳朵、肩膀和髋部应在一条直线上，肚子贴着妈妈的肚子，头部不要扭转。</p>
<p><strong>第四步：引导含接</strong><br />用左手呈"C"字形托住乳房，用乳头轻触宝宝的嘴唇，等宝宝嘴巴张大时，迅速将宝宝靠近乳房。</p>
<h2>摇篮式适用场景</h2>
<ul>
<li>足月顺产的宝宝</li>
<li>妈妈体力恢复后</li>
<li>白天在家哺乳</li>
<li>宝宝吸吮能力较强时</li>
</ul>`,
    category: 'feeding-positions',
    categoryName: '哺乳姿势动画',
    image: 'https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20cradle%20hold%20breastfeeding%20position%2C%20mother%20sitting%20comfortably%20holding%20baby%2C%20warm%20pastel%20cream%20and%20rose%20tones%2C%20gentle%20educational%20diagram%2C%20minimalist%20composition%2C%20clean%20background&width=800&height=500&seq=article-cradle-03&orientation=landscape',
    readTime: 4,
    date: '2026-07-22',
    tags: ['摇篮式', '哺乳姿势', '入门教程'],
    featured: false,
  },
  {
    id: 4,
    slug: 'football-hold-position',
    title: '橄榄球式哺乳姿势指南',
    excerpt: '橄榄球式特别适合剖腹产妈妈和双胞胎喂养，可以有效避免压迫腹部伤口，是很多妈妈的首选姿势。',
    content: `<p>橄榄球式（Football Hold）哺乳姿势，顾名思义，就像夹橄榄球一样将宝宝夹在身体一侧。这个姿势尤其适合剖腹产妈妈，因为宝宝不会压迫到腹部伤口。</p>
<h2>橄榄球式哺乳步骤</h2>
<p><strong>第一步：准备支撑</strong><br />在身体侧面放置2-3个枕头或专用哺乳枕，高度与乳房齐平。枕头应能稳定支撑宝宝的整个身体。</p>
<p><strong>第二步：将宝宝放在侧面</strong><br />宝宝的腿朝向后方，身体沿妈妈的前臂，头部用手掌托住。宝宝的身体呈倾斜姿势，面朝妈妈。</p>
<p><strong>第三步：调整高度</strong><br />确保宝宝的嘴巴正对乳头，不需要宝宝仰头或妈妈弯腰。</p>
<p><strong>第四步：引导含接</strong><br />用另一只手呈"C"字形托住乳房，等宝宝张大嘴巴时引导含接。</p>
<h2>橄榄球式的特殊优势</h2>
<ul>
<li>不压迫剖腹产伤口</li>
<li>适合乳房较大的妈妈</li>
<li>方便同时喂养双胞胎</li>
<li>早产儿或吸吮力弱的宝宝更容易含接</li>
</ul>`,
    category: 'feeding-positions',
    categoryName: '哺乳姿势动画',
    image: 'https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20football%20hold%20breastfeeding%20position%2C%20mother%20holding%20baby%20at%20side%2C%20warm%20pastel%20colors%2C%20gentle%20educational%20diagram%2C%20minimalist%20composition%2C%20clean%20cream%20background&width=800&height=500&seq=article-football-04&orientation=landscape',
    readTime: 4,
    date: '2026-07-25',
    tags: ['橄榄球式', '剖腹产', '双胞胎'],
    featured: false,
  },
  {
    id: 5,
    slug: 'power-pumping-technique',
    title: '追奶神器：Power Pumping 强力吸奶法',
    excerpt: 'Power Pumping是国际认证泌乳顾问推荐的追奶方法，模拟宝宝密集吸吮模式，有效提升奶量。',
    content: `<p>如果你觉得奶水不够，别急着加奶粉！Power Pumping（强力吸奶法）是国际上最受推崇的科学追奶方法之一，通过模拟宝宝的"猛长期"密集吸吮模式，向身体发出"需要更多奶水"的信号。</p>
<h2>Power Pumping 操作方案</h2>
<p><strong>标准方案（总时长约1小时）：</strong></p>
<ul>
<li>吸奶 20 分钟</li>
<li>休息 10 分钟</li>
<li>吸奶 10 分钟</li>
<li>休息 10 分钟</li>
<li>吸奶 10 分钟</li>
</ul>
<p>每天坚持一次，连续3-7天，多数妈妈在3天左右就能看到奶量明显增加。</p>
<h2>提升 Power Pumping 效果的小技巧</h2>
<ul>
<li><strong>选择合适的时间：</strong>早晨或深夜是泌乳素水平最高的时段</li>
<li><strong>保持放松：</strong>听舒缓音乐、深呼吸，避免盯着奶瓶看</li>
<li><strong>按摩乳房：</strong>吸奶前和吸奶过程中轻轻按摩乳房</li>
<li><strong>温热敷：</strong>吸奶前用温热毛巾敷乳房3-5分钟</li>
<li><strong>补充水分：</strong>准备一大杯温水在手边</li>
</ul>`,
    category: 'milk-boosting',
    categoryName: '追奶技巧',
    image: 'https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20breast%20pump%20and%20milk%20bottle%2C%20warm%20cozy%20home%20setting%2C%20gentle%20pastel%20cream%20and%20rose%20tones%2C%20minimalist%20composition%2C%20supportive%20motherhood%20theme%2C%20clean%20background&width=800&height=500&seq=article-power-pump-05&orientation=landscape',
    readTime: 5,
    date: '2026-08-01',
    tags: ['Power Pumping', '追奶方法', '泌乳顾问'],
    featured: true,
  },
  {
    id: 6,
    slug: 'galactagogue-foods',
    title: '催乳食物大全：吃对食物奶水自然多',
    excerpt: '科学验证的催乳食材清单，从传统月子汤到现代营养学，全面了解哪些食物真正有助于增加奶水分泌。',
    content: `<p>"吃什么奶水多？"这是每位哺乳妈妈都会关心的问题。虽然奶水分泌主要靠供需平衡，但合理的饮食确实能为产奶提供充足的"原料"。</p>
<h2>科学验证的催乳食物</h2>
<p><strong>1. 燕麦</strong><br />富含铁、纤维和皂苷，有助于刺激催乳素分泌。早餐一碗燕麦粥，简单又有效。</p>
<p><strong>2. 茴香</strong><br />含有植物雌激素类似物，传统上被广泛用于催乳。可以泡茴香茶饮用。</p>
<p><strong>3. 黑芝麻</strong><br />富含钙、铁和优质脂肪，是传统的产后滋补食材。</p>
<p><strong>4. 木瓜</strong><br />青木瓜炖汤是东南亚传统催乳食谱，含有促进泌乳的酶类。</p>
<p><strong>5. 鲫鱼</strong><br />中国传统催乳首选，鲫鱼汤营养丰富且易于吸收。</p>
<h2>需要避免的食物</h2>
<ul>
<li>大量薄荷（可能抑制泌乳）</li>
<li>酒精（会进入乳汁影响宝宝）</li>
<li>过量咖啡因（可能导致宝宝烦躁）</li>
<li>高汞鱼类（如鲨鱼、剑鱼）</li>
</ul>`,
    category: 'milk-boosting',
    categoryName: '追奶技巧',
    image: 'https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20healthy%20lactation%20foods%2C%20oats%20almonds%20papaya%20and%20herbs%20on%20wooden%20table%2C%20soft%20natural%20light%2C%20cream%20and%20warm%20beige%20tones%2C%20minimalist%20food%20photography%2C%20clean%20composition&width=800&height=500&seq=article-galactagogue-06&orientation=landscape',
    readTime: 6,
    date: '2026-08-05',
    tags: ['催乳食物', '营养饮食', '传统食疗'],
    featured: false,
  },
  {
    id: 7,
    slug: 'gentle-weaning-guide',
    title: '温和断奶全攻略：从纯母乳到自主进食',
    excerpt: '断奶不应该是突然的分离，而是一个循序渐进的温柔过渡。了解断奶的最佳时机和科学方法。',
    content: `<p>断奶是每个母乳妈妈和宝宝都要经历的重要阶段。世界卫生组织建议纯母乳喂养至6个月，并持续母乳喂养至2岁或更久。无论如何，断奶应该是一个充满爱和耐心的过程。</p>
<h2>断奶的最佳时机</h2>
<p>断奶没有统一的时间表，最佳时机取决于妈妈和宝宝的准备情况。以下信号可以帮助判断：</p>
<ul>
<li>宝宝对辅食表现出浓厚兴趣</li>
<li>宝宝能够较好地咀嚼和吞咽固体食物</li>
<li>哺乳不再是宝宝安抚的主要方式</li>
<li>妈妈身体或心理准备好减少哺乳</li>
</ul>
<h2>温和断奶四步法</h2>
<p><strong>第一步：选择容易替代的一餐开始</strong><br />通常从中午那餐开始，用辅食或配方奶替代一次哺乳。维持1-2周。</p>
<p><strong>第二步：逐步增加替代餐次</strong><br />每1-2周减少一次哺乳，用其他食物或活动替代。最后减少的是早上和睡前的哺乳。</p>
<p><strong>第三步：用其他安抚方式替代</strong><br />增加拥抱、读绘本、唱摇篮曲等亲子互动，替代哺乳的安抚功能。</p>
<p><strong>第四步：关注乳房健康</strong><br />逐步减少哺乳频率，让奶量自然下降。如有胀痛，挤出少量乳汁缓解，不要完全排空。</p>
<h2>断奶过程中的注意事项</h2>
<ul>
<li>不建议在宝宝生病、出牙或环境变化时断奶</li>
<li>避免"分离式断奶"，这会增加宝宝的焦虑</li>
<li>断奶期间多给宝宝拥抱和关注</li>
</ul>`,
    category: 'weaning',
    categoryName: '断奶过渡',
    image: 'https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20baby%20eating%20solid%20food%20happily%2C%20warm%20home%20kitchen%20setting%2C%20gentle%20pastel%20cream%20and%20soft%20peach%20tones%2C%20minimalist%20composition%2C%20nurturing%20motherhood%20scene%2C%20clean%20background&width=800&height=500&seq=article-weaning-07&orientation=landscape',
    readTime: 7,
    date: '2026-08-08',
    tags: ['断奶方法', '辅食添加', '过渡期'],
    featured: true,
  },
  {
    id: 8,
    slug: 'night-weaning-strategies',
    title: '夜奶断奶策略：让妈妈和宝宝都睡个好觉',
    excerpt: '夜奶是断奶中最具挑战性的一环。学习科学的夜奶断奶方法，帮助宝宝建立良好的睡眠习惯。',
    content: `<p>夜奶是许多哺乳妈妈最困扰的问题。当宝宝到了一定月龄，夜奶更多是一种习惯而非营养需求。以下是科学的夜奶断奶策略。</p>
<h2>判断是否可以考虑断夜奶</h2>
<p>一般来说，以下情况可以考虑开始逐步减少夜奶：</p>
<ul>
<li>宝宝月龄超过6个月</li>
<li>体重增长正常，白天进食良好</li>
<li>儿科医生确认宝宝夜间不再需要额外营养</li>
<li>夜醒吸吮时间短，更像安抚而非进食</li>
</ul>
<h2>温和减少夜奶的五个策略</h2>
<p><strong>策略一：逐步缩短夜间哺乳时间</strong><br />每晚减少1-2分钟的哺乳时间，逐步降低宝宝对夜奶的期待。</p>
<p><strong>策略二：改变安抚方式</strong><br />夜醒时先尝试拍拍、轻轻摇晃等方式安抚，而不是立刻喂奶。</p>
<p><strong>策略三：由爸爸参与夜间安抚</strong><br />当宝宝闻到妈妈身上的奶味时，更容易想要吃奶。由爸爸进行夜间安抚能减少宝宝对吃奶的联想。</p>
<p><strong>策略四：增加白天进食量</strong><br />确保宝宝白天摄入足够的热量和营养，减少夜间饥饿的可能。</p>
<p><strong>策略五：建立固定的睡前例行程序</strong><br />洗澡-按摩-读绘本-哺乳-入睡，固定的睡前流程帮助宝宝建立"该睡觉了"的条件反射。</p>`,
    category: 'weaning',
    categoryName: '断奶过渡',
    image: 'https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20baby%20sleeping%20peacefully%20in%20crib%2C%20gentle%20nighttime%20nursery%20scene%2C%20warm%20dim%20lighting%2C%20pastel%20cream%20and%20lavender%20tones%2C%20minimalist%20composition%2C%20calm%20atmosphere&width=800&height=500&seq=article-night-wean-08&orientation=landscape',
    readTime: 5,
    date: '2026-08-09',
    tags: ['夜奶', '睡眠训练', '断夜奶'],
    featured: false,
  },
  {
    id: 9,
    slug: 'breast-engorgement-relief',
    title: '涨奶缓解方法：奶水太多怎么办？',
    excerpt: '涨奶是产后常见问题，严重时可能导致乳腺炎。学习科学的涨奶处理方法，让乳房恢复舒适。',
    content: `<p>产后3-5天的"生理性涨奶"是很多妈妈遇到的挑战。了解涨奶的原因和处理方法，可以有效预防和缓解不适。</p>
<h2>涨奶的原因</h2>
<ul>
<li>产后激素变化导致乳汁大量产生</li>
<li>哺乳间隔时间过长</li>
<li>宝宝含接不良导致排空不充分</li>
<li>突然减少哺乳次数</li>
</ul>
<h2>缓解涨奶的有效方法</h2>
<p><strong>1. 冷敷（非热敷！）</strong><br />哺乳后用卷心菜叶或冷敷袋冷敷乳房10-15分钟，可以减少局部血流，缓解肿胀。注意：严重的涨奶不推荐热敷。</p>
<p><strong>2. 反向按压软化</strong><br />哺乳前用手指轻轻按压乳晕周围1-2分钟，将水肿液推开，方便宝宝含接。</p>
<p><strong>3. 频繁哺乳</strong><br />每2-3小时哺乳一次，确保充分排空。如果宝宝吸吮力不够，可配合吸奶器。</p>
<p><strong>4. 轻柔按摩</strong><br />哺乳时从乳房外围向乳头方向轻柔按摩，帮助乳汁流出。</p>`,
    category: 'milk-secretion',
    categoryName: '奶水分泌原理',
    image: 'https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20breastfeeding%20comfort%20and%20care%2C%20gentle%20hand%20massage%20technique%2C%20warm%20pastel%20cream%20and%20rose%20tones%2C%20minimalist%20medical%20illustration%2C%20clean%20background&width=800&height=500&seq=article-engorgement-09&orientation=landscape',
    readTime: 4,
    date: '2026-07-18',
    tags: ['涨奶', '乳房护理', '乳腺炎预防'],
    featured: false,
  },
  {
    id: 10,
    slug: 'side-lying-position',
    title: '侧躺式哺乳：夜间喂奶的最佳姿势',
    excerpt: '侧躺式哺乳让妈妈在夜间也能舒适喂奶，是产后恢复期和夜间哺乳的神器姿势。',
    content: `<p>侧躺式（Side-lying Position）是夜间哺乳和产后恢复期最受欢迎的姿势。它能让你在喂奶的同时获得休息，特别适合剖腹产后的妈妈。</p>
<h2>侧躺式哺乳步骤</h2>
<p><strong>第一步：妈妈侧躺</strong><br />身体完全侧躺，头部枕在枕头上，膝盖微弯。背后可以放一个枕头支撑。</p>
<p><strong>第二步：宝宝侧躺面对妈妈</strong><br />宝宝也侧躺，肚子贴着妈妈的肚子，嘴巴正对乳头。可以在宝宝背后放卷起的毛巾防止后仰。</p>
<p><strong>第三步：调整高度</strong><br />下方手臂可以放在宝宝头部上方或下方，确保宝宝的嘴巴能够轻松够到乳头。</p>
<p><strong>第四步：引导含接</strong><br />用上方手臂托住乳房，等宝宝张大嘴巴时引导含接。</p>
<h2>安全提醒</h2>
<ul>
<li>不要在过软的床垫或沙发上侧躺哺乳</li>
<li>确保宝宝周围没有被褥等可能导致窒息的物品</li>
<li>喂完后将宝宝放回独立的婴儿床</li>
</ul>`,
    category: 'feeding-positions',
    categoryName: '哺乳姿势动画',
    image: 'https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20side-lying%20breastfeeding%20position%2C%20mother%20and%20baby%20lying%20on%20bed%2C%20gentle%20nighttime%20scene%2C%20warm%20pastel%20cream%20and%20soft%20rose%20tones%2C%20minimalist%20composition%2C%20calm%20atmosphere&width=800&height=500&seq=article-side-lying-10&orientation=landscape',
    readTime: 4,
    date: '2026-07-28',
    tags: ['侧躺式', '夜间哺乳', '剖腹产'],
    featured: false,
  },
  {
    id: 11,
    slug: 'milk-storage-guide',
    title: '母乳储存完全指南：保鲜、冷冻与解冻',
    excerpt: '背奶妈妈的必修课！了解母乳的正确储存方法，确保每一滴珍贵的母乳都得到妥善保存。',
    content: `<p>对于需要重返职场或偶尔外出的哺乳妈妈来说，正确储存母乳是一项必备技能。不当的储存方式可能导致母乳变质，浪费珍贵的奶水。</p>
<h2>母乳储存时间表</h2>
<p><strong>室温（25°C以下）：</strong>4小时<br /><strong>冷藏（4°C）：</strong>4天<br /><strong>冷冻（-18°C以下）：</strong>6个月<br /><strong>深冻（-20°C以下）：</strong>12个月</p>
<h2>储存容器选择</h2>
<ul>
<li><strong>母乳储存袋：</strong>最方便，不占空间，适合冷冻</li>
<li><strong>玻璃瓶：</strong>适合冷藏，可重复使用</li>
<li><strong>食品级塑料瓶：</strong>选择BPA-free材质</li>
</ul>
<h2>解冻方法</h2>
<ul>
<li><strong>推荐方法：</strong>提前放入冷藏室解冻（约12小时）</li>
<li><strong>快速方法：</strong>用流动的温水（不超过40°C）冲淋</li>
<li><strong>禁止：</strong>微波炉加热或用沸水加热</li>
</ul>`,
    category: 'milk-boosting',
    categoryName: '追奶技巧',
    image: 'https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20breast%20milk%20storage%20bags%20and%20bottles%2C%20organized%20freezer%20scene%2C%20warm%20pastel%20cream%20and%20soft%20beige%20tones%2C%20clean%20minimalist%20composition%2C%20practical%20motherhood%20theme&width=800&height=500&seq=article-storage-11&orientation=landscape',
    readTime: 5,
    date: '2026-08-02',
    tags: ['母乳储存', '背奶', '解冻方法'],
    featured: false,
  },
  {
    id: 12,
    slug: 'baby-led-weaning',
    title: '宝宝主导式断奶（BLW）：让宝宝自己决定',
    excerpt: '宝宝主导式断奶是一种尊重宝宝自主意愿的断奶方式，让断奶过程更自然、更温和。',
    content: `<p>宝宝主导式断奶（Baby-Led Weaning, BLW）是一种尊重宝宝自主权的断奶方式。与传统的"妈妈主导断奶"不同，BLW让宝宝根据自己的需求和节奏，自然地减少哺乳。</p>
<h2>BLW断奶的核心原则</h2>
<ul>
<li><strong>不主动、不拒绝：</strong>妈妈不主动提供哺乳，但宝宝要求时不拒绝</li>
<li><strong>分散注意力：</strong>在宝宝可能想吃奶的时间段，提供有趣的辅食或活动</li>
<li><strong>改变日常节奏：</strong>调整哺乳相关的日常生活习惯</li>
<li><strong>耐心等待：</strong>尊重宝宝的自然节奏，不设硬性时间表</li>
</ul>
<h2>BLW适合什么样的家庭？</h2>
<p>BLW适合能够灵活安排时间、不急于断奶的家庭。宝宝的月龄通常在1岁以上，已经建立了良好的辅食基础。这种方式的优点是过程自然温和，宝宝和妈妈都能舒适过渡。</p>`,
    category: 'weaning',
    categoryName: '断奶过渡',
    image: 'https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20baby%20happily%20self-feeding%20finger%20foods%2C%20warm%20kitchen%20scene%2C%20gentle%20pastel%20cream%20and%20soft%20peach%20tones%2C%20minimalist%20composition%2C%20independent%20eating%20theme&width=800&height=500&seq=article-blw-12&orientation=landscape',
    readTime: 4,
    date: '2026-08-10',
    tags: ['BLW', '宝宝主导', '自然断奶'],
    featured: false,
  },
];